import getValues from "backend/values";
import * as wf from "client-api-workflow";
import workflowAttributes from "../workflowAttributes";
import { getPeriodLevels } from "./getPeriodLevels";
import { getPeriods } from "./getPeriods";
import { ICardElementWithChildren } from "./model";

export const getWorkflowInstance = async (workflowInstanceId: string) => {
  const workflowInstance = await wf.getInstance(workflowInstanceId, true);
  const modelId = `SC.${workflowInstance.meaId.split(".")[1]}`;
  const periods = await getPeriods(modelId);
  const periodLevels = await getPeriodLevels(modelId);
  const values = await getValues(
    workflowInstance.meaId,
    periods.filter((n) => n.name === workflowInstance.period),
    true,
    periodLevels.map((level) => {
      return {
        id: level.id,
        name: level.name,
        periods: periods.filter((p) => p.periodlevel === level.id),
      };
    }),
    workflowAttributes
  );
  return {
    ...values[0],
    workflowInstance,
  } as ICardElementWithChildren;
};
